import { render, staticRenderFns } from "./RecurringProjectHero.vue?vue&type=template&id=bb8eec88&"
import script from "./RecurringProjectHero.vue?vue&type=script&lang=js&"
export * from "./RecurringProjectHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports